var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNutritionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 42.019,
    height: 42.847,
    transform: "translate(0 0)",
    fill: "#ffef73",
    stroke: "#ffef73",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3702",
    "data-name": "Group 3702",
    transform: "translate(-158 -109)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 143",
    cx: 29.5,
    cy: 29.5,
    r: 29.5,
    transform: "translate(158 109)",
    fill: "#ffef73"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(166.578 116.67)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M33.01,21.881a6.157,6.157,0,0,1-3.934-10.336l.923-.99L28.766,10a12.3,12.3,0,0,0-5.043-1.021,11.912,11.912,0,0,0-5.338,1.152,6.074,6.074,0,0,1,4.529-4.032l-.3-1.923a7.011,7.011,0,0,0-3.684,1.756A7.1,7.1,0,0,0,11.868,0l-.575.008-.287.36a7.191,7.191,0,0,0-.844,7.622,7.29,7.29,0,0,0,.595.992c-.113,0-.226-.01-.338-.01C5.416,8.971.053,11.655,0,19.185a21.035,21.035,0,0,0,8.988,17.95,4.439,4.439,0,0,0,2.556.724,10.964,10.964,0,0,0,4.724-1.377,1.566,1.566,0,0,1,.745-.165,2.428,2.428,0,0,1,.951.211,10.886,10.886,0,0,0,4.641,1.331h0a4.432,4.432,0,0,0,2.556-.724A20.9,20.9,0,0,0,33.882,23l.155-1.021ZM11.909,7.13a5.23,5.23,0,0,1,.345-5.169,5.185,5.185,0,0,1,3.961,8.055A5.237,5.237,0,0,1,15,9.777q-.187-.074-.378-.139A5.146,5.146,0,0,1,11.909,7.13m12.154,28.4a2.541,2.541,0,0,1-1.456.384,9.067,9.067,0,0,1-3.727-1.1l-.085-.043a4.362,4.362,0,0,0-1.782-.4,3.44,3.44,0,0,0-1.758.449,8.9,8.9,0,0,1-3.711,1.093,2.552,2.552,0,0,1-1.458-.384A19.111,19.111,0,0,1,1.948,19.2C2,11.723,7.889,10.917,10.42,10.917a11.329,11.329,0,0,1,3.387.5q.307.128.626.227a3.951,3.951,0,0,1,.754.406l.067.044a3.843,3.843,0,0,0,.809.343,3.545,3.545,0,0,1-2.829.307.974.974,0,0,0-.649,1.836,5.238,5.238,0,0,0,1.714.275,5.427,5.427,0,0,0,4.823-2.9,9.439,9.439,0,0,1,4.6-1.036,11.062,11.062,0,0,1,3.055.413,8.106,8.106,0,0,0,5.013,12.324,18.907,18.907,0,0,1-7.728,11.871",
    transform: "translate(3.991 2.494)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNutritionIcon);
export default __webpack_public_path__ + "static/media/nutritionIcon.463cfccc3c6b08f357635997eca03e46.svg";
export { ForwardRef as ReactComponent };